import { IChannel } from '@/entities/channel';
import { Switch } from '@/shared/ui/Switch';

import { useUpdateChannel } from '../../model/useUpdateChannel';

type ActiveSwitcherProps = {
  channel: IChannel;
};

export const ActiveSwitcher = ({ channel }: ActiveSwitcherProps) => {
  const { updateChannel, isPending } = useUpdateChannel();

  const handleToggleActive = async (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    await updateChannel({
      channelId: channel.id,
      is_active: checked,
    });
  };

  return (
    <Switch
      checked={channel.is_active}
      onChange={handleToggleActive}
      disabled={isPending}
    />
  );
};
